<div class="password-rules__title">La contraseña debe poseer:</div>
<ul class="password-rules__list">
  <li class="password-rules__item" *ngFor="let rule of rules"
    [class.restriction-fullfilled]="value && value.match(rule.ruleRegExp)">{{rule.description}}</li>
</ul>